<script lang="ts">
	import PageGrid from '../components/pageGrid.svelte';
	import Video from '$lib/video.svelte';
	import BtnMute from '$lib/buttons/v2/btnMute.svelte';
	import { scale } from 'svelte/transition';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData['content'] & {
			playback_id: string;
		};
	}

	let { content }: Props = $props();
</script>

<div use:editable={content}>
	<PageGrid class="mb-8 mt-10">
		<Video
			playbackId={content.playback_id}
			wrapperClass="col-span-full lg:col-start-4 lg:col-end-10"
			class="h-full w-full overflow-hidden rounded-2xl object-center"
		>
			{#snippet children(videoElement, loaded)}
				{#if loaded}
					<div
						class="absolute right-3 top-3 z-20 rounded-full bg-[#240d0214] lg:right-6 lg:top-6"
						in:scale
					>
						<BtnMute {videoElement} />
					</div>
				{/if}
			{/snippet}
		</Video>
	</PageGrid>
</div>
